import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Modal, Button, Icon, Form, Popup, Checkbox, Message } from "semantic-ui-react";
import AlertContainer from "react-alert";
import ReactQuill from "react-quill";

import { UserInput } from "../../components";
import ACTIONS from "./actions";
import Context from "./context";

import Service from "./service";

const EDIT_MODAL_ACTIONS = [ACTIONS.EDIT_MODAL_SHOW, ACTIONS.EDIT_MODAL_SAVE];

const newKiosk = { id: 0, name: "", confirmation_title: "", confirmation_image_url: null };

class KioskEditModal extends Component {
  static contextType = Context;

  state = {
    selectedKioskIndex: this.context.selectedKioskIndex,
    kiosk: { ...newKiosk },
    incompleteForm: false,
    incompleteCustomWebpageText: false,
  };

  componentDidUpdate() {
    const { action, selectedKioskIndex, kiosks } = this.context;

    if ([null, ...EDIT_MODAL_ACTIONS].includes(action) && this.state.selectedKioskIndex !== selectedKioskIndex) {
      const kiosk = [-1, null].includes(selectedKioskIndex) ? { ...newKiosk } : kiosks[selectedKioskIndex];
      this.setState({ kiosk, selectedKioskIndex });
    }
  }

  isCustomWebPageTextInvalid = () => {
    const { is_custom_web_page_enabled, custom_web_page_display_text } = this.state.kiosk;

    if (!is_custom_web_page_enabled) return false;

    const href = this.handleExtractHrefFromCustomWebPageDisplayText();

    if (!custom_web_page_display_text || !href) {
      this.setState({ incompleteCustomWebpageText: true });

      return true;
    }

    return false;
  };

  onSave = () => {
    const { kiosk } = this.state;
    if (!kiosk.name || !kiosk.confirmation_title || !kiosk.confirmation_image_url) this.setState({ incompleteForm: true });
    else if (this.isCustomWebPageTextInvalid()) return;
    else this.setState({ incompleteForm: false }, () => this.context.controller.submitKiosk(this.state.kiosk));
  };

  uploadConfirmationImage = file => {
    const { kiosk } = this.state;
    const {
      globalState: { selectedLocation },
    } = this.context;

    const extension = file.name.lastIndexOf(".") > -1 ? file.name.slice(file.name.lastIndexOf(".") + 1) : "unknown";
    const uploadFile = new File([file], file.name, { type: file.type || extension });
    const formData = new FormData();

    formData.append("file", uploadFile);
    formData.append("dealer_location_id", selectedLocation.id);

    Service.addConfirmationImage(formData)
      .then(res => {
        if (res?.data?.data?.url) {
          this.setState({ kiosk: { ...kiosk, confirmation_image_url: res.data.data.url } });
        } else throw new Error("Error uploading image");
      })
      .catch(err => {
        console.error("Error uploading image:", err);
        this.msg.show(err.message, { type: "error" });
      });
  };

  uploadStandbyImage = file => {
    const { kiosk } = this.state;
    const {
      globalState: { selectedLocation },
    } = this.context;

    const extension = file.name.lastIndexOf(".") > -1 ? file.name.slice(file.name.lastIndexOf(".") + 1) : "unknown";
    const uploadFile = new File([file], file.name, { type: file.type || extension });
    const formData = new FormData();

    formData.append("file", uploadFile);
    formData.append("dealer_location_id", selectedLocation.id);

    Service.addStandbyImage(formData)
      .then(res => {
        if (res?.data?.data?.url) {
          this.setState({ kiosk: { ...kiosk, stand_by_image_url: res.data.data.url } });
        } else throw new Error("Error uploading image");
      })
      .catch(err => {
        console.error("Error uploading image:", err);
        this.msg.show(err.message, { type: "error" });
      });
  };

  handleUploadStandbyImage = e => {
    this.uploadStandbyImage(e.target.files[0]);
  };

  handleUploadConfirmationImage = e => {
    this.uploadConfirmationImage(e.target.files[0]);
  };

  handleCustomWebPageDisplayTextChange = custom_web_page_display_text => {
    if (this.state.incompleteCustomWebpageText) this.setState({ incompleteCustomWebpageText: false });

    this.setState(({ kiosk }) => ({ kiosk: { ...kiosk, custom_web_page_display_text } }));
  };

  handleExtractHrefFromCustomWebPageDisplayText = () => {
    const { custom_web_page_display_text } = this.state.kiosk;

    const html = new DOMParser().parseFromString(custom_web_page_display_text, "text/html");
    const anchor = html.querySelector("a[href]");

    if (anchor) return anchor.getAttribute("href");

    return null;
  };

  renderAlert = () => {
    const props = {
      offset: 20,
      position: "top right",
      theme: "light",
      time: 2000,
      transition: "fade",
    };
    return <AlertContainer ref={a => (this.msg = a)} {...props} />;
  };

  close = () => {
    this.setState({ incompleteCustomWebpageText: false });

    this.context.controller.setAction(null);
  };

  render() {
    const { kiosk, incompleteForm, incompleteCustomWebpageText } = this.state;
    const { t } = this.props;
    const { isLoading, selectedKioskIndex, action } = this.context;

    const isOpen = selectedKioskIndex !== null && EDIT_MODAL_ACTIONS.includes(action);
    const customWebPageHref = this.handleExtractHrefFromCustomWebPageDisplayText();

    return (
      <Modal className="KioskEditModal" open={isOpen} onClose={this.close} closeOnDimmerClick={false} size="small">
        <Modal.Header>
          <div>{selectedKioskIndex > -1 ? t("edit_kiosk").message || "Edit Kiosk" : t("add_kiosk").message || "Add Kiosk"}</div>
        </Modal.Header>

        <Modal.Content scrolling>
          <Form>
            <Form.Field error={incompleteForm && !kiosk.name}>
              <UserInput
                type="text"
                placeholder={t("name").message || "Name"}
                value={kiosk.name}
                onChange={(_event, data) => this.setState({ kiosk: { ...kiosk, name: data.value } })}
              />
            </Form.Field>

            <Form.Field error={incompleteForm && !kiosk.confirmation_title}>
              <UserInput
                type="text"
                placeholder={t("confirmation_title").message || "Confirmation title"}
                value={kiosk.confirmation_title}
                onChange={(_event, data) => this.setState({ kiosk: { ...kiosk, confirmation_title: data.value } })}
              />
            </Form.Field>

            <Form.Field error={incompleteForm && !kiosk.confirmation_image_url}>
              <label>{t("confirmation_image").message || "Confirmation image"}</label>
              <input type="file" ref={this.fileInputRef} onChange={this.handleUploadConfirmationImage} accept="image/png, image/jpeg, image/jpg" />
              {kiosk.confirmation_image_url && (
                <div className="KioskImageContainer">
                  <img src={kiosk.confirmation_image_url} alt="" />
                </div>
              )}
            </Form.Field>

            <Form.Field>
              <label>
                {t("standby_image").message || "Standby image"}
                <Popup
                  trigger={<Icon className="KioskImageInfo" name="info circle" />}
                  content={`${t("optimal_image_resolution").message || "Optimal image resolution"}: 1080x1920`}
                  inverted
                />
              </label>
              <input type="file" onChange={this.handleUploadStandbyImage} accept="image/png, image/jpeg, image/jpg" />
              {kiosk.stand_by_image_url && (
                <div className="KioskImageContainer">
                  <img src={kiosk.stand_by_image_url} alt="" />
                </div>
              )}
            </Form.Field>

            <Form.Field>
              <Checkbox
                toggle
                name="is_custom_web_page_enabled"
                label={t("active_kiosk_additional_screen").message || "Active Kiosk additional screen"}
                checked={kiosk.is_custom_web_page_enabled}
                onChange={(_event, { checked: is_custom_web_page_enabled }) =>
                  this.setState({ kiosk: { ...kiosk, is_custom_web_page_enabled, custom_web_page_display_text: "", customWebPageHref: null } })
                }
              />
            </Form.Field>

            {incompleteCustomWebpageText && (
              <Message negative className="custom-webapage-error-msg">
                <h4>{t("no_url_entered").message || "No URL Entered"}</h4>
              </Message>
            )}

            {kiosk.is_custom_web_page_enabled && (
              <Form.Field>
                <ReactQuill
                  modules={{ toolbar: ["bold", "italic", "underline", "link"] }}
                  value={kiosk.custom_web_page_display_text}
                  onChange={this.handleCustomWebPageDisplayTextChange}
                  className={`KioskQuill ${incompleteCustomWebpageText ? "QuillError" : ""}`}
                />
              </Form.Field>
            )}
          </Form>

          {customWebPageHref && kiosk.is_custom_web_page_enabled && (
            <div className="custom-web-page-preview-container">
              <div className="custom-web-page-preview-title">{t("link_preview").message || "Link Preview"}</div>
              <iframe title="Custom Web page Preview" className="custom-web-page-preview" src={customWebPageHref}></iframe>
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button floated="left" negative icon="close" disabled={isLoading} content={t("cancel").message || "Cancel"} onClick={this.close} />
          <Button color="green" onClick={() => this.onSave()} loading={isLoading} disabled={isLoading}>
            <Icon name="checkmark" /> {t("save").message || "SAVE"}
          </Button>
        </Modal.Actions>

        {this.renderAlert()}
      </Modal>
    );
  }
}

export default withTranslation()(KioskEditModal);
